<template>
  <el-drawer
    :visible.sync="visible"
    :wrapperClosable="false"
    :with-header="false"
    direction="rtl"
    size="40%"
    id="addS1"
    :destroy-on-close="true"
  >
    <el-container style="height: 100%">
      <el-header height="auto">
        <fw-header :titles="title" />
      </el-header>
      <el-main>
        <div class="bar" v-if="shippers">
          <div class="imgs">
            <i class="fa fa-truck"></i>
          </div>
          <div class="info" :title="`${shippers.ShipperName} ${dataInfo.LogisticCode}`">
            {{ `${shippers.ShipperName} ${dataInfo.LogisticCode}` }}
          </div>
          <div class="copy_text" @click="copy">
            复制
          </div>
        </div>
        <div v-for="(item, index) in shippersArr" :key="index">
          <div class="ship_bar">
            <div class="ship_bar_title" :style="`color:${index == 0 ? '#fc600c' : '#cccccc'}`">
              <i class="fa fa-circle"></i>
              <div>{{ item.ActionText }}</div>
              <div>{{ item.AcceptTime }}</div>
            </div>
            <div
              class="ship_bar_info"
              :style="
                `color:${index == 0 ? '#333' : '#cccccc'};border-left:${
                  index + 1 == shippersArr.length ? '0px' : '1px solid #ebebeb'
                }`
              "
            >
              <div class="text" v-html="item.formattedStation"></div>
            </div>
          </div>
        </div>
        <div class="receive_bar" v-if="receiveInfo && receiveInfo.receive_name">
          <div class="cyc">收</div>
          <div class="text">
            {{
              `${receiveInfo.receive_name || "--"}, ${receiveInfo.receive_mobile ||
                "--"}, ${receiveInfo.receive_address || "--"}`
            }}
          </div>
        </div>
      </el-main>
      <el-footer>
        <el-row>
          <el-col :span="24" align="center">
            <el-button size="small" @click="close">取消</el-button>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-drawer>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  created() {},
  mounted() {},
  data() {
    return {
      visible: false,
      callFn: null, //回调
      chosedID: null,
      title: "物流详情",
      defaultParmas: {},
      dataInfo: null,
      shippers: null,
      receiveInfo: null,
    };
  },
  watch: {},
  computed: {
    shippersArr() {
      if (this.dataInfo && this.dataInfo.Traces && this.dataInfo.Traces.length) {
        let arr = [...this.dataInfo.Traces].reverse();
        // 预处理，添加格式化后的字段
        return arr.map(item => ({
          ...item,
          formattedStation: this.formatAcceptStation(item.AcceptStation)
        }));
      }
      return [];
    },
  },
  methods: {
    async open(data, callFn) {
      console.log("🚀 ~ data:", data);
      for (let key in data) {
        this[key] = data[key];
      }
      this.query();
      this.callFn = callFn;
      this.visible = true;
    },
    query() {
      let params = {
        ...this.defaultParmas,
      };
      let api = "/eo/express/query";
      this.$axios.postJSON(api, params).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.data;
          this.getShipper();
        }
      });
    },
    getShipper() {
      let params = {
        ...this.defaultParmas,
      };
      let api = "/eo/express/query_excompany";
      this.$axios.postJSON(api, params).then(res => {
        if (res.code == 200) {
          let Shippers = res.data.Shippers || [];
          if (Shippers && Shippers.length) {
            this.shippers = Shippers[0];
          }
        }
      });
    },
    formatAcceptStation(text) {
      if (!text) return '';
      return text.replace(
        /(1[3-9]\d{9}|\d{3,4}-\d{7,8}|\d{7,8}(?:-\d+)?)/g,
        '<span style="color: #fc600c;">$1</span>'
      );
    },
    async copy() {
      let text = `${this.dataInfo.LogisticCode}`;
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success("已复制到粘贴板");
      } catch (err) {
        console.error("复制到剪贴板失败:", err);
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding-left: 25px;
  padding-right: 25px;
}
.bar {
  padding: 16px;
  background-color: #fafafa;
  gap: 20px;
  display: flex;
  align-items: center;
  .imgs {
    font-size: 20px;
    color: #73ccf3;
  }
  .info {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .copy_text {
    min-width: 100px;
    color: #2e91fc;
    cursor: pointer;
  }
}
.receive_bar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  .cyc {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffefe6;
    color: #fc600c;
  }
  .text {
    flex: 1;
  }
}
.ship_bar {
  .ship_bar_title {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .ship_bar_info {
    margin-left: 5px;
    padding-left: 30px;
    border-left: 1px solid #ebebeb;
    .text {
      word-wrap: break-word; /* 当单词太长时自动换行 */
      word-break: break-all; /* 使单词在任意字符内换行，避免单词被截断 */
      padding: 10px 0;
    }
  }
}
</style>
